/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccessNumberListItemPagedResult } from '../../models/access-number-list-item-paged-result';
import { AccessNumberSearchRequest } from '../../models/access-number-search-request';

export interface PostAccessnumberMinifiedSearchV2$Json$Params {
  'api-version'?: string;
      body?: AccessNumberSearchRequest
}

export function postAccessnumberMinifiedSearchV2$Json(http: HttpClient, rootUrl: string, params?: PostAccessnumberMinifiedSearchV2$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AccessNumberListItemPagedResult>> {
  const rb = new RequestBuilder(rootUrl, postAccessnumberMinifiedSearchV2$Json.PATH, 'post');
  if (params) {
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AccessNumberListItemPagedResult>;
    })
  );
}

postAccessnumberMinifiedSearchV2$Json.PATH = '/accessnumber/minified/search-v2';
